module.exports = __webpack_public_path__ + "img/my.741d5ade.svg";